<style scoped>
  .zoezi-apple-button {
    height: 40px;
    width: 250px;
    display: block;
    text-align: center;
    font-size: 17px;
    font-weight: 400;
    border-radius: 8px;
    border: 1px solid #000;
  }
</style>

<template>
  <div v-if="appHandlesSignin">
    <v-btn class="zoezi-apple-button" color="black" dark @click="signinThroughApp()">
      <v-icon left>mdi-apple</v-icon>
      {{$translate("Sign in with Apple")}}
    </v-btn>
  </div>
  <div v-else id="appleid-signin" data-height="40px" data-width="250px" data-color="black" data-border="true"
    data-mode="center-align" data-type="sign-in">
  </div>
</template>
<script>
import { isExpoApp, appHandlesAppleSignin } from '../util.js';

export default {
  name: 'zoezi-apple-signin',
  zoezi: {
    title: 'Sign in with Apple',
    icon: 'mdi-apple'
  },
  metaInfo: ({ $store }) => {
    const uuid = require('uuid/v4');
    const nonce = uuid();

    localStorage.setItem('apple-signin-nonce', nonce);

    let state = {};
    state.origin = window.location.origin;
    state.path = window.location.pathname;
    state.redirect = `${state.origin}${state.path}`;

    const client_id = 'com.runningsystems.gymsystem.zoezi.signin';

    // Set to sv_SE for Swedish else en_US
    const lang = $store.state.language == 'sv' ? 'sv_SE' : 'en_US';
    return {
      meta: [
        { name: "appleid-signin-client-id", content: client_id },
        { name: "appleid-signin-scope", content: "name email" },
        { name: "appleid-signin-redirect-uri", content: "https://apple-auth.zoezi.se" },
        { name: "appleid-signin-state", content: JSON.stringify(state) },
        { name: "appleid-signin-nonce", content: nonce.toString() },
        { name: "appleid-signin-use-popup", content: "false" }
      ],
      script: [
        { src: `https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/${lang}/appleid.auth.js` }
      ]
    };
  },
  computed: {
    appHandlesSignin() {
      return appHandlesAppleSignin();
    },
    isExpoApp() {
      return isExpoApp();
    }
  },
  methods: {
    signinThroughApp() {
      if (window.ReactNativeWebView) {
        window.ReactNativeWebView.postMessage(JSON.stringify({ type: 'appleAuth', data: {nonce: localStorage.getItem('apple-signin-nonce'), state: this.state()} }));
      }
    },
    state() {
      let state = {}
      state.origin = window.location.origin;
      state.path = window.location.pathname;
      state.redirect = `${state.origin}${state.path}`;
      return state
    }
  }
}
</script>
